<template>
  <section class="section"/>
  <div class="dg-container">
    <div class="row row-grid align-items-center d-flex justify-content-between">
      <div class="col-lg-5 order-md-1 hidden-sm-and-down">
        <img src="img/homepage/2-1.png" class="img-fluid floating"/>
      </div>
      <div class="col-lg-2 order-md-2"></div>
      <div class="col-lg-5 order-md-3">
        <div>
          <p class="hp-title2 mb-5">Shape DeFi Protection Ecosystem</p>
          <p class="fw-9 d-p fs-28">To Protect <span class="d-g2">with safety.</span></p>
          <p class="fw-9 d-p fs-28">To Earn <span class="d-g2">with yield.</span></p>
          <p class="fw-9 d-p fs-28">To Play <span class="d-g2">with fun.</span></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "defi",
};
</script>

<style scoped>

</style>
